require('./payrollLoanPaginator.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const classNames = require('classnames');

class PayrollLoanPaginator extends React.Component {
    constructor(props) {
        super(props);

        this.handleBack = this.handleBack.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    buildLeftArrow() {
        const { pages, current } = this.props;
        const className = classNames(
            'payroll-loan-paginator__arrow',
            {
                'payroll-loan-paginator__arrow--disabled': current === 0
            }
        );

        return pages > 1 ? (
            <div className={className} onClick={this.handleBack}>
                <i className="icon icon-anterior" />
            </div>
        ) : null;
    }

    buildPages() {
        const { pages, current } = this.props;
        const list = [];

        for (let i = 0; i < pages; i++) {
            const value = i + 1;
            const className = classNames(
                'payroll-loan-paginator__page',
                {
                    'payroll-loan-paginator__page--current': i === current
                }
            );

            list.push(
                <div key={'page-' + i} className={className}
                    onClick={() => this.handleChange(i)}>
                    {value}
                </div>
            );
        }

        return list;
    }

    buildRightArrow() {
        const { pages, current } = this.props;
        const className = classNames(
            'payroll-loan-paginator__arrow',
            {
                'payroll-loan-paginator__arrow--disabled': current === (pages - 1)
            }
        );

        return pages > 1 ? (
            <div className={className} onClick={this.handleNext}>
                <i className="icon icon-siguiente" />
            </div>
        ) : null;
    }

    handleBack() {
        const { current, onPageChange } = this.props;

        if (current > 0) {
            onPageChange(current - 1);
        }
    }

    handleChange(index) {
        const { onPageChange } = this.props;

        onPageChange(index);
    }

    handleNext() {
        const { current, pages, onPageChange } = this.props;

        if (current < (pages - 1)) {
            onPageChange(current + 1);
        }
    }

    render() {
        const leftButton = this.buildLeftArrow();
        const rightButton = this.buildRightArrow();
        const pagesList = this.buildPages();

        return (
            <div className="payroll-loan-paginator">
                {leftButton}
                {pagesList}
                {rightButton}
            </div>
        );
    }
}

PayrollLoanPaginator.propTypes = {
    current: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    pages: PropTypes.number.isRequired
};

module.exports = PayrollLoanPaginator;